<template>
  <div class="controls">
    <div class="controls__filter">
      <div
        aria-controls="filters-dropdown"
        class="btn -has-icon -dual upper"
        @click="toggleFilterDropdown"
      >
        <span class="iconfont-filter" />Topics<span class="iconfont-carrot" />
      </div>

      <div
        v-if="dropdownFilterActive"
        class="dropdown-overlay"
        @click.prevent="toggleFilterDropdown"
      />
      <div
        v-if="dropdownFilterActive"
        id="filters-dropdown"
        class="dropdown-menu-holder"
        @mouseleave="
          () => {
            !isMobileWidth() && toggleFilterDropdown()
          }
        "
      >
        <div class="dropdown-menu">
          <header class="header">
            <h4 class="heading -small">
              Filter
            </h4>
            <button class="hamburger -exed" @click.prevent="toggleFilterDropdown">
              <span class="inner">
                <i />
              </span>
            </button>
          </header>

          <ul>
            <li
              v-for="(cat, index) in categories"
              :key="index"
              :class="{ open: index === categoryIndex }"
            >
              <a
                :class="{ active: isCatActive(cat.title, index) || index === categoryIndex }"
                :href="cat.url + query"
                @mouseenter="
                  () => {
                    !isMobileWidth() && changeCategory(index)
                  }
                "
                @click.prevent="changeCategory(index, !isMobileWidth(), cat.url + query)"
                >{{ cat.title }}<span class="iconfont-carrot"
              /></a>
              <ul class="mobile-submenu">
                <li>
                  <a :href="cat.url + query">{{ cat.title }}</a>
                </li>
                <!-- eslint-disable-next-line -->
                <li v-for="subcat in subcategories[0]">
                  <a :class="{ active: isCatActive(subcat.title) }" :href="subcat.url + query">{{
                    subcat.title
                  }}</a>
                </li>
              </ul>
            </li>
          </ul>
          <div class="submenu">
            <!-- eslint-disable-next-line -->
            <ul v-for="subcatList in subcategories">
              <!-- eslint-disable-next-line -->
              <li v-for="subcat in subcatList">
                <a :class="{ active: isCatActive(subcat.title) }" :href="subcat.url + query">{{
                  subcat.title
                }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-right">
      <div class="discussion-action">
        <a href="/community/create" class="btn -main">Start a Discussion</a>
        <a href="/community/create" class="discussion-icon"><span class="iconfont-discussion"/></a>
      </div>

      <button class="btn -has-icon icon-only" @click="toggleSearchDropdown">
        <span class="sr-only">search</span><span class="iconfont-search" />
      </button>

      <form
        v-show="searchDropdownActive"
        action="POST"
        class="search-form-small"
        @mouseleave="toggleSearchDropdown"
        @submit.prevent="onSearchSubmit"
      >
        <div class="inner">
          <label class="sr-only" for="search">Search</label>
          <input
            id="search"
            ref="searchInput"
            type="text"
            placeholder="Keyword Search"
            class="large-input"
          />
          <button type="submit">
            <span class="sr-only">Search</span><span class="iconfont-search" />
          </button>
        </div>
      </form>

      <div class="form__group -inline">
        <label for="sort">Sort</label>
        <div class="select-style">
          <form>
            <select v-model="sortValue" @change="handleSort($event.target.value)">
              <option value="newest">
                Newest First
              </option>
              <option value="updated">
                Last Update
              </option>
              <option value="popular">
                Most Popular
              </option>
              <option value="oldest">
                Oldest First
              </option>
            </select>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @flow
import Vue from 'vue'
import { communitySort, communitySearch } from 'app/utils/events'
import { bp } from 'app/constants'

export default {
  data() {
    return {
      categoryIndex: !Laravel.communityActiveCat || !Laravel.communityActiveSubcat ? -1 : -1,
      dropdownFilterActive: false,
      searchDropdownActive: false,
    }
  },
  computed: {
    sortValue() {
      return this.$route.query.sort || 'newest'
    },
    categories() {
      return Laravel.communityCategories
    },
    subcategories(): Array<Array<Category>> {
      if (this.categoryIndex < 0) {
        return []
      }

      const index = this.categoryIndex
      const subcats = Laravel.communityCategories[index].subcategories || []

      if (subcats.length > this.categories.length) {
        const half = Math.ceil(subcats.length / 2)
        return [subcats.slice(0, half), subcats.slice(half)]
      } else {
        return [subcats]
      }
    },
    query() {
      const sort = this.$route.query.sort
      const keywords = this.$route.query.keywords
      if (keywords && sort) {
        return `?sort=${sort}&keywords=${keywords}`
      } else if (sort) {
        return `?sort=${sort}`
      } else if (keywords) {
        return `?keywords=${keywords}`
      } else {
        return ''
      }
    },
  },
  methods: {
    isMobileWidth() {
      const winWidth = window.innerWidth
      return bp.small >= winWidth
    },
    changeCategory(index: number, redirect: boolean = false, url: string = '') {
      if (!redirect) {
        this.categoryIndex = this.categoryIndex === index ? -1 : index
      } else {
        window.location = url
      }
    },
    isCatActive(title: string, index: ?number = null) {
      const { communityActiveCat, communityActiveSubcat } = Laravel

      if (!communityActiveCat && !communityActiveSubcat) {
        return
      }

      title = title.replace(/&/g, '&amp;')

      const matchesActiveCatTitle = communityActiveCat && title === communityActiveCat.title
      const matchesActiveSubcatTitle =
        communityActiveSubcat && title === communityActiveSubcat.title

      const isActive = matchesActiveCatTitle || matchesActiveSubcatTitle

      if (isActive && index && !this.isMobileWidth) {
        this.categoryIndex === -1 && this.changeCategory(index)
      }

      return isActive
    },
    toggleFilterDropdown() {
      this.dropdownFilterActive = !this.dropdownFilterActive
      !this.dropdownFilterActive && this.changeCategory(-1)
    },
    toggleSearchDropdown() {
      this.searchDropdownActive = !this.searchDropdownActive
      if (this.searchDropdownActive) {
        Vue.nextTick(() => {
          this.$refs.searchInput && this.$refs.searchInput.focus()
        })
      }
    },
    handleSort(value: string) {
      const query = this.$route.query
      if (query.keywords) {
        communitySort(value, `${this.$route.path}?keywords=${query.keywords}`, true)
      } else {
        communitySort(value, this.$route.path)
      }
    },
    onSearchSubmit() {
      const query = this.$route.query
      if (query.sort) {
        communitySearch(
          this.$refs.searchInput.value,
          `${this.$route.path}?sort=${query.sort}`,
          true,
        )
      } else {
        communitySearch(this.$refs.searchInput.value, this.$route.path)
      }
    },
  },
}
</script>
